import React from "react";


const ViewWaterProfile = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const formatNumber = (value) => 
    value !== null && value !== undefined ? value.toFixed(2) : "N/A";

  const chemicalProperties = [
    { label: "Calcium", value: formatNumber(profile.calcium), unit: "mg/L" },
    { label: "Total Alkalinity", value: formatNumber(profile.totalAlkalinity), unit: "mg/L" },
    { label: "Bicarbonate", value: formatNumber(profile.bicarbonate), unit: "mg/L" },
    { label: "Sulfate", value: formatNumber(profile.sulfate), unit: "mg/L" },
    { label: "Magnesium", value: formatNumber(profile.magnesium), unit: "mg/L" },
    { label: "Total Hardness", value: formatNumber(profile.totalHardness), unit: "mg/L" },
    { label: "Iron", value: formatNumber(profile.iron), unit: "mg/L" },
    { label: "pH", value: formatNumber(profile.pH), unit: "" },
    { label: "Total Chlorine", value: formatNumber(profile.totalChlorine), unit: "mg/L" },
    { label: "Residual Alkalinity", value: formatNumber(profile.residualAlkalinity), unit: "mg/L" },
    { label: "Chloride", value: formatNumber(profile.chloride), unit: "mg/L" },
    { label: "Sulfate to Chloride Ratio", value: formatNumber(profile.sulfateToChlorideRatio), unit: "" },
    { label: "Sodium", value: formatNumber(profile.sodium), unit: "mg/L" },
    { label: "Zinc", value: formatNumber(profile.zinc), unit: "mg/L" },
    { label: "Potassium", value: formatNumber(profile.potassium), unit: "mg/L" },
    { label: "Copper", value: formatNumber(profile.copper), unit: "mg/L" },
    { label: "TDS", value: formatNumber(profile.tds), unit: "mg/L" },
  ];

return (
  <div className="box">
    <h2 className="title is-4">Water Profile Details</h2>
    
    <div className="columns is-multiline">
      {/* Basic Information */}
      <div className="column is-6">
        <p className="subtitle is-6">
          <strong>Account Number:</strong> {profile.accountNumber || "N/A"}
        </p>
      </div>
      <div className="column is-6">
        <p className="subtitle is-6">
          <strong>Type:</strong> {profile.type || "N/A"}
        </p>
      </div>

      {/* Chemical Properties */}
      <div className="column is-12">
        <h3 className="title is-5">Chemical Properties</h3>
      </div>
      
      {chemicalProperties.map((prop, index) => (
        <div 
          className="column is-6-mobile is-4-tablet is-3-desktop" 
          key={index}
        >
          <p className="subtitle is-6">
            <strong>{prop.label}:</strong> {prop.value} {prop.unit}
          </p>
        </div>
      ))}

      {/* Audit Information */}
      <div className="column is-12">
        <h3 className="title is-5">Audit Information</h3>
      </div>
      <div className="column is-6">
        <p className="subtitle is-6">
          <strong>Created At:</strong>{" "}
          {profile.createdAt ? new Date(profile.createdAt).toLocaleString() : "N/A"}
        </p>
      </div>
      <div className="column is-6">
        <p className="subtitle is-6">
          <strong>Created By:</strong> {profile.createdBy || "N/A"}
        </p>
      </div>
      {profile.modifiedAt && (
        <div className="column is-6">
          <p className="subtitle is-6">
            <strong>Modified At:</strong>{" "}
            {new Date(profile.modifiedAt).toLocaleString()}
          </p>
        </div>
      )}
      {profile.modifiedBy && (
        <div className="column is-6">
          <p className="subtitle is-6">
            <strong>Modified By:</strong> {profile.modifiedBy}
          </p>
        </div>
      )}
    </div>
  </div>
);
};

export default ViewWaterProfile;